import { isAvailableBecauseCanEditFile } from '@/app/actions';
import { Action } from '@/app/actions/actions';
import type { ActionSpecRecord } from '@/app/actions/actionsSpec';
import { sheets } from '@/app/grid/controller/Sheets';
import * as gridSettings from '@/app/gridGL/pixiApp/gridSettings';
import { javascriptWebWorker } from '@/app/web-workers/javascriptWebWorker/javascriptWebWorker';
import { pythonWebWorker } from '@/app/web-workers/pythonWebWorker/pythonWebWorker';
import { quadraticCore } from '@/app/web-workers/quadraticCore/quadraticCore';
import { SaveAndRunIcon } from '@/shared/components/Icons';

type CodeActionSpec = Pick<
  ActionSpecRecord,
  Action.CancelExecution | Action.ExecuteCode | Action.RerunSheetCode | Action.RerunAllCode
>;

export const cancelExecution = () => {
  // Clear all pending executions (queued transactions + pending ops in current transaction)
  quadraticCore.clearAllPendingExecutions();

  // Cancel all language workers
  pythonWebWorker.cancelExecution();
  javascriptWebWorker.cancelExecution();
  quadraticCore.sendCancelConnectionExecutions();
};

export const executeCode = () => {
  const selection = sheets.sheet.cursor.a1String();
  quadraticCore.rerunCodeCells(sheets.current, selection, false);
};

export const rerunSheetCode = () => {
  quadraticCore.rerunCodeCells(sheets.current, undefined, false);
};

export const rerunAllCode = () => {
  quadraticCore.rerunCodeCells(undefined, undefined, false);
};

export const codeActionsSpec: CodeActionSpec = {
  [Action.CancelExecution]: {
    label: () => 'Cancel execution',
    isAvailable: isAvailableBecauseCanEditFile,
    run: () => {
      gridSettings.setContextMenu({});
      cancelExecution();
    },
  },
  [Action.ExecuteCode]: {
    label: () => 'Run code',
    Icon: SaveAndRunIcon,
    isAvailable: isAvailableBecauseCanEditFile,
    run: () => {
      gridSettings.setContextMenu({});
      executeCode();
    },
  },
  [Action.RerunSheetCode]: {
    label: () => 'Run sheet code',
    isAvailable: isAvailableBecauseCanEditFile,
    run: () => {
      gridSettings.setContextMenu({});
      rerunSheetCode();
    },
  },
  [Action.RerunAllCode]: {
    label: () => 'Run all code',
    isAvailable: isAvailableBecauseCanEditFile,
    run: () => {
      gridSettings.setContextMenu({});
      rerunAllCode();
    },
  },
};
